import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { Subscription } from 'rxjs/Subscription';
import { EventsService } from '../shared/bdb-event.service';
import { ChannelService } from '../shared/channel.service';
import { DispatcherService } from '../shared/dispatcher.service';
import { ParticipantService } from '../shared/participant.service';
import { RedirectService } from '../shared/redirect.service';
import { AdviserService } from '../shared/adviser.service';
import { environment } from '../../../environments/environment';
import { ServiceErrorEnum } from '../enums/service-error.enum';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import { BdbAbstentionService } from '../shared/bdb-abstention.service';
import { SingleSessionService } from '../shared/single-session.service';
import { AssistedStorage } from '../shared/assistedStorage/assistedStorage';
import { InitialLoad } from '../shared/assistedStorage/models/IAssitedStorage';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'bdb-identity-number',
  templateUrl: './bdb-identity-number.component.html',
  styleUrls: ['./bdb-identity-number.component.scss']
})

export class BdbIdentityNumberComponent implements OnInit, OnDestroy, AfterViewInit {

  private mediumTypesOTP: string[] = environment.mediumTypesOTP.split(',');
  private suscrip: Subscription;

  @Input() saveCheckIdentity = false;
  @Input() authCard: String;

  identityNumber: string;
  cellphoneNumber: string;
  validDocumentNumber = true;
  validCellphoneNumber = true;
  isCellphoneEnabled: boolean = false;

  @ViewChild('loader') loaderBdb: ElementRef;
  @ViewChild('modal') modalBdb: ElementRef;

  modalFunctionYes: Function;

  constructor(
    private channelService: ChannelService,
    private dispatcherService: DispatcherService,
    private eventsService: EventsService,
    private participantService: ParticipantService,
    private redirectService: RedirectService,
    private routes: Router,
    private sessionStorageService: BdbSessionStrgService,
    private adviserService: AdviserService,
    private bdbAbstentionService: BdbAbstentionService,
    private singleSessionService: SingleSessionService,
    private assistedStorage: AssistedStorage
  ) { }

  ngOnDestroy(): void {
    if (this.suscrip) {
      this.suscrip.unsubscribe();
    }
  }

  ngOnInit() {
    this.checkMediumType();
    this.verifyIfUserHasAlreadyAcceptedTACs();
  }

  ngAfterViewInit(): void {
    this.loaderBdb.nativeElement.openLoader();
    const privateIp = this.sessionStorageService.get(SessionStorageKeysEnum.PRIVATE_IP);
    if (privateIp !== 'null') {
      if (!this.redirectService.checkInitialParams()) {
        this.redirectService.saveInitialParams();
      }
    }
    this.loaderBdb.nativeElement.closeLoader();
  }

  private verifyIfUserHasAlreadyAcceptedTACs() {
    const userAcceptedTAC = this.sessionStorageService.get(SessionStorageKeysEnum.USER_ACCEPTED_TAC);
    this.saveCheckIdentity = userAcceptedTAC === 'true';
    const identityNumber = this.sessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER);
    if (!!identityNumber) {
      this.identityNumber = identityNumber;
    }
  }

  private checkMediumType() {
    const mediumType = this.sessionStorageService.get(SessionStorageKeysEnum.MEDIUM_TYPE);
    this.isCellphoneEnabled = this.mediumTypesOTP.includes(mediumType);
  }

  valCheckIdentity() {
    this.saveCheckIdentity = !this.saveCheckIdentity;
    const saveCheckIdentityStringValue = this.saveCheckIdentity ? 'true' : 'false';
    this.sessionStorageService.save(SessionStorageKeysEnum.USER_ACCEPTED_TAC, saveCheckIdentityStringValue);
    this.validateIdentity();
    this.validateCellphoneNumber();
  }

  validateIdentity() {
    const idNumberFromSessionStorage = this.identityNumber;
    if (idNumberFromSessionStorage === undefined || idNumberFromSessionStorage === null) {
      return;
    }
    const idNumber = idNumberFromSessionStorage.replace(/\D/g, '');
    this.sessionStorageService.save(SessionStorageKeysEnum.IDENTITY_NUMBER, idNumber);
    this.validDocumentNumber = this.isValidIdentityNumber(idNumber);
  }

  validateCellphoneNumber() {
    if (this.cellphoneNumber === undefined || this.cellphoneNumber === null) {
      return;
    }
    let num = (this.cellphoneNumber as string);
    num = num.replace(/\D/g, '');
    num = num.substring(0, 10);
    this.cellphoneNumber = num;
    this.sessionStorageService.save(SessionStorageKeysEnum.CELL_PHONE_NUMBER, this.cellphoneNumber);
    this.validCellphoneNumber = this.isValidCellphoneNumber(this.cellphoneNumber);
  }

  private isValidIdentityNumber(idNumber: string) {
    const validLength = idNumber && idNumber.length > 5 && idNumber.length !== 9;
    const pattern = new RegExp(/^(?!0\w*)(\d{6,8}|\d{10})$/);
    const validPattern = pattern.test(idNumber);
    return validLength && validPattern;
  }

  private isValidCellphoneNumber(cellphone: string) {
    const pattern = new RegExp(/[3](01|02|03|04|05|06|10|11|12|13|14|15|16|00|17|18|19|20|21|22|23|50|51)[1-9]{1}[0-9]{6}/);
    return pattern.test(cellphone);
  }

  enableNextButton() {
    const acceptedTAC = this.saveCheckIdentity;
    const validIdentityNumber = (this.identityNumber !== null && this.identityNumber !== undefined) && this.validDocumentNumber;
    if (this.isCellphoneEnabled) {
      const validCellphoneNumber = (this.cellphoneNumber !== null && this.cellphoneNumber !== undefined) && this.validCellphoneNumber;
      return validIdentityNumber && validCellphoneNumber && acceptedTAC;
    } else {
      return validIdentityNumber && acceptedTAC;
    }
  }

  async redirectIdentity() {
    this.loaderBdb.nativeElement.openLoader();
    this.singleSessionService.initIntervalCallSingleSession(this.identityNumber,
      this.sessionStorageService.get(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER_LAUNCHER),
      this.sessionStorageService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO_UUID));
    if (environment.enableParticipantStateIAC) {
      await this.participantService.getParticipantStateWithSandboxV3(this.sessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER))
        .then(async response => {
          this.sessionStorageService.save(SessionStorageKeysEnum.CUSTOMER_STATE, atob(response.body));
          this.generateUuid().then(async (uuidAuth) => {
            this.sessionStorageService.save(SessionStorageKeysEnum.UUID_AUTH, uuidAuth.toString());
            this.updateClientAssociationWithAdviser();
            const customerState = this.sessionStorageService.get(SessionStorageKeysEnum.CUSTOMER_STATE);
            const site = this.sessionStorageService.get(SessionStorageKeysEnum.SITE);
            if ( customerState === 'NOT_CLIENT' && site === '11') {
              this.routes.navigate(['error-page']);
              return;
            }
            await this.redirect();
          }).catch(() => {
            this.callModalServiceError(ServiceErrorEnum.SAVE_DATA_DISPATCHER_ERROR, () => {
              this.redirectService.quit();
            });
          });
        })
        .catch(error => {
          console.log('Error participant state service --> ', error);
          this.callModalServiceError(ServiceErrorEnum.CUSTOMER_STATE_ERROR, () => {
            this.redirectService.quit();
          });
        })
    } else {
      this.participantService.getParticipantState(this.sessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER))
        .subscribe(async (response) => {
          if (response.status === 201) {
            this.sessionStorageService.save(SessionStorageKeysEnum.CUSTOMER_STATE, atob(response._body));
            this.generateUuid().then(async (uuidAuth) => {
              this.sessionStorageService.save(SessionStorageKeysEnum.UUID_AUTH, uuidAuth.toString());
              this.updateClientAssociationWithAdviser();
              const customerState = this.sessionStorageService.get(SessionStorageKeysEnum.CUSTOMER_STATE);
              const site = this.sessionStorageService.get(SessionStorageKeysEnum.SITE);
              if ( customerState === 'NOT_CLIENT' && site === '11') {
                this.routes.navigate(['error-page']);
                return;
              }
              await this.redirect();
            }).catch(() => {
              this.callModalServiceError(ServiceErrorEnum.SAVE_DATA_DISPATCHER_ERROR, () => {
                this.redirectService.quit();
              });
            });
          } else {
            this.sessionStorageService.save(SessionStorageKeysEnum.MILESTONE, 'ingreso-autenticador');
            this.callModalServiceError(ServiceErrorEnum.CUSTOMER_STATE_ERROR, () => {
              this.redirectService.quit();
            });
          }
        });
    }
  }

  private async generateUuid(): Promise<string> {
    const dataToShare = {
      identityNumber: this.sessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER),
      identityType: this.sessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE),
      productId: this.sessionStorageService.get(SessionStorageKeysEnum.PRODUCT),
      officeCode: this.sessionStorageService.get(SessionStorageKeysEnum.OFFICE_CODE),
      customerState: this.sessionStorageService.get(SessionStorageKeysEnum.CUSTOMER_STATE),
      network: this.sessionStorageService.get(SessionStorageKeysEnum.PRIVATE_IP),
      channel: this.channelService.getChannel(),
      utmUuid: this.sessionStorageService.get(SessionStorageKeysEnum.UTM_UUID),
      specificProductInfoUuid: this.sessionStorageService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO_UUID),
      site: this.sessionStorageService.get(SessionStorageKeysEnum.SITE),
      firstAuthAttempt: this.sessionStorageService.get(SessionStorageKeysEnum.FIRST_AUTH_ATTEMPT)
    };
    this.redirectService.getEncryptDataToDispatcher(dataToShare);
    const initialLoad: InitialLoad = await this.assistedStorage.getByKey('initialLoad')
    return new Promise<string>((resolve, reject) => {
      if (initialLoad.useSandboxDispatcher) {
        this.dispatcherService.saveInfoDispacherSandbox(dataToShare)
          .then(response => {
            if (response.status === 201) {
              const responseAuth = response.body;
              resolve(responseAuth.uuid);
            } else {
              reject('Error create uuid');
            }
          });
      } else {
        this.dispatcherService.saveInfoAuthenticated(dataToShare).subscribe(response => {
          const responseAuth = JSON.parse(response._body);
          if (response.status === 201) {
            resolve(responseAuth.uuid);
          } else {
            reject('Error create uuid');
          }
        });
      }
    });
  }

  updateClientAssociationWithAdviser() {
    if (this.adviserService.isAuthAdviserEnabled()) {
      this.adviserService.updateClientAssociation().subscribe(response => {
        console.log('RESPONSE updateClientAssociationWithAdviser: ', response);
      }, error => {
        console.log('ERROR updateClientAssociationWithAdviser: ', error);
        this.callModalServiceError(ServiceErrorEnum.CLIENT_ASSOCIATION_WITH_SELLER_SERVICE_ERROR, () => {
          this.redirectService.quit();
        });
      });
    }
  }

  async redirect() {
    const dataEvent = this.eventsService.prepareEventAcceptance(1);
    this.eventsService.sendEvent(dataEvent).subscribe(_ => { });
    this.sessionStorageService.save(SessionStorageKeysEnum.MILESTONE, 'ingreso-autenticador');
    const isAllowedToContinue = await this.bdbAbstentionService.checkAbstentionList();
    if (!isAllowedToContinue) {
      this.callModalServiceError(ServiceErrorEnum.ABSTENTION_LIST_ERROR, () => {
        location.reload();
      });
    } else {
      this.loaderBdb.nativeElement.closeLoader();
      this.routes.navigate(['expedition-date']);
    }
  }

  goToRegulationIdentity() {
    const idNumber = this.identityNumber;
    if (idNumber !== undefined && idNumber !== null) {
      this.sessionStorageService.save(SessionStorageKeysEnum.IDENTITY_NUMBER, idNumber);
    }
    if (this.cellphoneNumber !== undefined && this.cellphoneNumber !== null) {
      this.sessionStorageService.save(SessionStorageKeysEnum.CELL_PHONE_NUMBER, this.cellphoneNumber);
    }
    this.loaderBdb.nativeElement.closeLoader();
    this.routes.navigate(['regulation-products']);
  }

  callModalServiceError(errorCode: ServiceErrorEnum, callbackYes: Function) {
    let errTitle = '';
    let errDesc = '';
    this.modalFunctionYes = callbackYes;
    switch (errorCode) {
      case ServiceErrorEnum.CLIENT_ASSOCIATION_WITH_SELLER_SERVICE_ERROR:
        errTitle = `Error validando información`;
        errDesc = `Se han encontrado algunas inconsistencias en la información. (${ServiceErrorEnum.CLIENT_ASSOCIATION_WITH_SELLER_SERVICE_ERROR})`;
        break;
      case ServiceErrorEnum.ABSTENTION_LIST_ERROR:
        errTitle = `Error validando información`;
        errDesc = `Se han encontrado algunas inconsistencias en la información. (${ServiceErrorEnum.ABSTENTION_LIST_ERROR})`;
        break;
      case ServiceErrorEnum.SAVE_DATA_DISPATCHER_ERROR:
        errTitle = `Problemas al registrar la información`;
        errDesc = `No logramos guardar la información debido a un problema de comunicación. Verifica tu
        conexión a internet e intenta nuevamente. (${ServiceErrorEnum.SAVE_DATA_DISPATCHER_ERROR})`;
        break;
      case ServiceErrorEnum.CUSTOMER_STATE_ERROR:
        errTitle = `Problemas al consultar la información`;
        errDesc = `No logramos consultar la información debido a un problema de comunicación. Verifica tu conexión a
              internet e intenta nuevamente. (${ServiceErrorEnum.CUSTOMER_STATE_ERROR})`;
        break;
    }
    this.setModalTitles(errTitle, errDesc);
    this.loaderBdb.nativeElement.closeLoader();
    this.modalBdb.nativeElement.openAlert();
  }

  setModalTitles(title: string, subtitle: string) {
    this.modalBdb.nativeElement.titleModal = title
    this.modalBdb.nativeElement.subTitle = subtitle
  }

  actionButtomModalBdb() {
    this.modalFunctionYes()
  }

}



// WEBPACK FOOTER //
// ./src/app/bdb-identity-number/bdb-identity-number.component.ts